import { render, staticRenderFns } from "./odds.vue?vue&type=template&id=b9db7c44&scoped=true&"
import script from "./odds.vue?vue&type=script&lang=js&"
export * from "./odds.vue?vue&type=script&lang=js&"
import style0 from "./odds.vue?vue&type=style&index=0&id=b9db7c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db7c44",
  null
  
)

export default component.exports